export const enquiryApiURl = {
  getList: "/enquiry",
  addEnquiry: "/enquiry/add",
  updateEnquiry: "/enquiry/update",
  updateStatus: "/enquiry/update-status",
};
